/* tslint:disable */
/* eslint-disable */
/**
 * Geocoding API
 * Telematics services geocoding API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GeoStatsXyResponse
 */
export interface GeoStatsXyResponse {
    /**
     * 
     * @type {number}
     * @memberof GeoStatsXyResponse
     */
    hits: number;
}

export function GeoStatsXyResponseFromJSON(json: any): GeoStatsXyResponse {
    return GeoStatsXyResponseFromJSONTyped(json, false);
}

export function GeoStatsXyResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GeoStatsXyResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'hits': json['hits'],
    };
}

export function GeoStatsXyResponseToJSON(value?: GeoStatsXyResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'hits': value.hits,
    };
}


